import { render, staticRenderFns } from "./StylePreview.vue?vue&type=template&id=50a60e60&scoped=true"
import script from "./StylePreview.vue?vue&type=script&lang=js"
export * from "./StylePreview.vue?vue&type=script&lang=js"
import style0 from "./StylePreview.vue?vue&type=style&index=0&id=50a60e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a60e60",
  null
  
)

export default component.exports